export default __webpack_public_path__ + "static/media/dittoModel.0b3e46b9.glb";